import React from "react";

import SelectSituacao from "../../../../Components/SelectSituacao";
import SelectEnfermeiro from "../../../../Components/SelectEnfermeiro";
import AutoCompleteClientes from "../../../../../../componentsv2/AutoCompleteClientes";
import Button from "../../../../../../componentsv2/Button";
import Paper from "../../../../../../componentsv2/Paper";
import GridContainer from "../../../../../../componentsv2/GridContainer";
import GridItem from "../../../../../../componentsv2/GridItem";
import DataPickerAtualizado from "../../../../../../components/DataPickerAtualizado";

const campoFiltroSx = {
  display: "flex",
  alignItems: "flex-end",
  width: "100%",
  "& .MuiGrid-container": { margin: 0, width: "100%" },
  "& .MuiGrid-item": { padding: 0, maxWidth: "100%", flexBasis: "100%" },
  "& .MuiFormControl-root": { width: "100%", marginBottom: 0 },
  "& .MuiInputBase-root": { fontSize: "0.875rem" },
  "& .MuiInputLabel-root": { fontSize: "0.875rem" },
};

const datePickerSlotProps = {
  textField: {
    size: "small",
    variant: "standard",
    fullWidth: true,
  },
};

export default function Cabecalho(props) {
  const {
    onClick,
    situacao,
    setSituacao,
    enfermeiroId,
    setEnfermeiroId,
    cliente,
    setCliente,
    dataInicial,
    setDataInicial,
    dataFinal,
    setDataFinal,
  } = props;

  return (
    <Paper>
      <GridContainer
        sx={{
          display: "flex",
          alignItems: "flex-end",
          flexWrap: { xs: "wrap", md: "nowrap" },
          gap: 2,
          pl: 2,
          pr: "13px",
          py: "13px",
        }}
      >
        <GridItem
          xs={6}
          sx={{
            flex: { md: "0 0 145px" },
            maxWidth: { md: 145 },
            ...campoFiltroSx,
          }}
        >
          <DataPickerAtualizado
            data={dataInicial}
            setData={setDataInicial}
            formatarNaData
            variant="standard"
            labelName="Data inicial"
            slotProps={datePickerSlotProps}
          />
        </GridItem>

        <GridItem
          xs={6}
          sx={{
            flex: { md: "0 0 145px" },
            maxWidth: { md: 145 },
            ...campoFiltroSx,
          }}
        >
          <DataPickerAtualizado
            data={dataFinal}
            setData={setDataFinal}
            formatarNaData
            variant="standard"
            labelName="Data final"
            slotProps={datePickerSlotProps}
          />
        </GridItem>

        <GridItem
          xs={12}
          sx={{
            flex: { md: "1 1 240px" },
            minWidth: { md: 220 },
            ...campoFiltroSx,
          }}
        >
          <AutoCompleteClientes value={cliente} onChange={setCliente} />
        </GridItem>

        <GridItem
          xs={6}
          sx={{
            flex: { md: "0 0 130px" },
            maxWidth: { md: 130 },
            ...campoFiltroSx,
          }}
        >
          <SelectSituacao
            onChange={(e) => {
              setSituacao(e.target.value);
            }}
            value={situacao}
          />
        </GridItem>

        <GridItem
          xs={6}
          sx={{
            flex: { md: "1 1 160px" },
            minWidth: { md: 150 },
            ...campoFiltroSx,
          }}
        >
          <SelectEnfermeiro
            todos={true}
            onChange={(e) => {
              setEnfermeiroId(e.target.value);
            }}
            value={enfermeiroId}
          />
        </GridItem>

        <GridItem
          xs={12}
          sx={{
            flex: { md: "0 0 130px" },
            maxWidth: { md: 130 },
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <Button variant="contained" fullWidth onClick={onClick}>
            Adicionar
          </Button>
        </GridItem>
      </GridContainer>
    </Paper>
  );
}
